import React from 'react';
import { BookletPreview } from './BookletPreview';
import { PageIntro } from './PageIntro';
import { PageGLP1Overview } from './PageGLP1Overview';
import { PageGLP1Overview2 } from './PageGLP1Overview2';
import { PageGLP1Overview3 } from './PageGLP1Overview3';
import { PageGutSide } from './PageGutSide';
import { PageBrainSide } from './PageBrainSide';
import { Page1 } from './Page1';
import { PageTOC } from './PageTOC';
import { PageCopyright } from './PageCopyright';
import { DividerMedication } from './DividerMedication';
import { DividerFundamentals } from './DividerFundamentals';
import { DividerSupplements } from './DividerSupplements';
import { PageDoseManagement } from './PageDoseManagement';
import { PageDoseManagement2 } from './PageDoseManagement2';
import { Page2 } from './Page2';
import { Page2b } from './Page2b';
import { PageContext } from './PageContext';
import { PageEssentialsDivider } from './PageEssentialsDivider';
import { Page3 } from './Page3';
import { Page4 } from './Page4';
import { Page5 } from './Page5';
import { Page5b } from './Page5b';
import { Page6 } from './Page6';
import { Page7 } from './Page7';
import { Page8 } from './Page8';
import { Page9 } from './Page9';
import { Page10 } from './Page10';
import { Page11 } from './Page11';
import { Page12 } from './Page12';
import { PageMealTiming } from './PageMealTiming';
import { PageSupplementQuality } from './PageSupplementQuality';
import { PageHydration } from './PageHydration';
import { PageSleep } from './PageSleep';
import { DividerSideEffects } from './DividerSideEffects';
import { PageAcuteSideEffects } from './PageAcuteSideEffects';
import { PageChronicSideEffects } from './PageChronicSideEffects';
import { PageAlcohol } from './PageAlcohol';
import { PagePlateaus } from './PagePlateaus';
import { DividerLookingAhead } from './DividerLookingAhead';
import { PageTransitioning } from './PageTransitioning';
import { PageOutro } from './PageOutro';
import { PageOutro2 } from './PageOutro2';
import { PageAboutAuthor2 } from './PageAboutAuthor2';
import { FoodPhoto1 } from './FoodPhoto1';
import { FoodPhoto2 } from './FoodPhoto2';
import { FoodPhoto3 } from './FoodPhoto3';
import { FoodPhoto4 } from './FoodPhoto4';
import { FoodPhoto5 } from './FoodPhoto5';
// Supplement Pages
import { SupplementWheyProtein } from './SupplementWheyProtein';
import { SupplementMultiVitamin } from './SupplementMultiVitamin';
import { SupplementVitaminD } from './SupplementVitaminD';
import { SupplementCoQ10 } from './SupplementCoQ10';
import { SupplementElectrolytes } from './SupplementElectrolytes';
import { SupplementCreatine } from './SupplementCreatine';
import { SupplementSleepSupport } from './SupplementSleepSupport';
import { SupplementMagnesium } from './SupplementMagnesium';
import { SupplementAshwagandha } from './SupplementAshwagandha';
import { SupplementGlutathione } from './SupplementGlutathione';
import { SupplementOmega3 } from './SupplementOmega3';
import { SupplementAshwagandhaMuscle } from './SupplementAshwagandhaMuscle';
import { Printer, Lock, ShoppingCart } from 'lucide-react';
import { Link, useSearchParams } from 'react-router-dom';
export function Booklet() {
  const [searchParams] = useSearchParams();
  const isPreview = searchParams.get('preview') === '1';
  if (isPreview) {
    return <main className="min-h-screen bg-bodybg px-4 py-8 sm:px-6 sm:py-12" data-id="element-560" data-mp="3ktmba9cnt2u1">
        <BookletPreview data-id="element-561" data-mp="3kvqppl86pk8k" />

        <section className="mx-auto w-full max-w-3xl px-4 py-12 text-center sm:py-16" data-id="element-562" data-mp="2x3s0ryftbqcy">
          <Lock className="mx-auto mb-6 h-10 w-10 text-tealslate" data-id="element-563" data-mp="2x5wc31g1jrn9" />
          <p className="mb-4 text-[10px] font-bold uppercase tracking-[0.3em] text-tealslate" data-id="element-564" data-mp="2s6jjs16ehsda">
            End of Preview
          </p>
          <h1 className="mb-5 font-serif text-3xl leading-tight text-white md:text-4xl" data-id="element-565" data-mp="315n2h41no5r9">
            That&apos;s the first taste.
          </h1>
          <p className="mx-auto mb-10 max-w-xl text-base leading-relaxed text-[#D8D8D0]" data-id="element-566" data-mp="ld7l8tyhw1xh">
            The full GLP-1 Nutrition Guide includes 40+ pages of practical
            frameworks for protecting muscle, managing side effects, dialing in
            supplements, and building habits that outlast the prescription.
          </p>
          <Link to="/books" className="inline-flex items-center justify-center gap-2 px-8 py-4 text-[11px] font-bold uppercase tracking-[0.2em] text-white transition-colors hover:bg-tealslate/80" style={{
          backgroundColor: '#3B4A4F'
        }} data-id="element-567" data-mp="1gqrypnagn6xu">
            <ShoppingCart className="h-4 w-4" data-id="element-568" data-mp="1uo6r90w0fuu1" />
            Get the Full Guide
          </Link>
        </section>
      </main>;
  }
  return <>
      <button onClick={() => window.print()} className="print-button fixed top-6 right-6 z-50 bg-tealslate hover:bg-tealslate/80 text-white px-5 py-3 flex items-center gap-2 font-bold text-sm uppercase tracking-wider shadow-lg transition-colors" data-id="element-569" data-mp="24dqc2c3a9yrj">
        <Printer className="w-5 h-5" data-id="element-570" data-mp="2eamlql4x4qxo" />
        Save as PDF
      </button>
      <div className="print-container min-h-screen bg-bodybg py-12 flex flex-col items-center gap-12 overflow-y-auto" data-id="element-571" data-mp="2ieau361djqjz">
        <Page1 data-id="element-572" data-mp="6ocre3tt9cza" />
        <PageCopyright data-id="element-573" data-mp="2pcbat2pwofz" />
        <PageIntro data-id="element-574" data-mp="2oug7zrskg9n" />
        <PageTOC data-id="element-575" data-mp="2oawcdikzhsz" />
        {/* Part One: Understanding Your Medication */}
        <DividerMedication data-id="element-576" data-mp="3tulvg44168ho" />
        <PageGLP1Overview data-id="element-577" data-mp="3tvx86tfgeqkx" />
        <PageGLP1Overview2 data-id="element-578" data-mp="3tx8cqvgq42d3" />
        <PageGLP1Overview3 data-id="element-579" data-mp="3owu2r7vkaicf" />
        <PageGutSide data-id="element-580" data-mp="3oxlyqjt2mi38" />
        <PageBrainSide data-id="element-581" data-mp="3oy55d4d9tk1y" />
        <PageDoseManagement data-id="element-582" data-mp="qeot2hc424tw" />
        <PageDoseManagement2 data-id="element-583" data-mp="qeyavhn055oi" />
        <FoodPhoto1 data-id="element-584" data-mp="qe5dh79xnsj1" />
        {/* Part Two: The Fundamentals */}
        <DividerFundamentals data-id="element-585" data-mp="lfbvb1jpbdcj" />
        <Page2 data-id="element-586" data-mp="lg3radh7nd3c" />
        <Page2b data-id="element-587" data-mp="lhon06f9h22s" />
        <PageContext data-id="element-588" data-mp="govinjnpfvr8" />
        {/* Part Three: The Essentials */}
        <PageEssentialsDivider data-id="element-589" data-mp="gnakzl63fwp5" />
        <Page3 data-id="element-590" data-mp="bpsd7y3tbniq" />
        <Page4 data-id="element-591" data-mp="bqahni0mp81q" />
        <FoodPhoto2 data-id="element-592" data-mp="bqk63160z75b" />
        <Page6 data-id="element-593" data-mp="bp967cfpajjh" />
        <Page7 data-id="element-594" data-mp="bpinmbmojidk" />
        <Page8 data-id="element-595" data-mp="bnxzp4uvexoo" />
        <PageHydration data-id="element-596" data-mp="194wi5viz6ur3" />
        <FoodPhoto3 data-id="element-597" data-mp="1967von283gve" />
        <PageMealTiming data-id="element-598" data-mp="196r154aoscsj" />
        <Page5 data-id="element-599" data-mp="196zgr3y71w7f" />
        <Page5b data-id="element-600" data-mp="14eg0fz84gmyx" />
        <Page9 data-id="element-601" data-mp="14dy12tq5xsms" />
        <Page10 data-id="element-602" data-mp="14deoztn71ygo" />
        <PageSleep data-id="element-603" data-mp="14cva6lsubq6v" />
        <Page11 data-id="element-604" data-mp="14cd46xgdlxlr" />
        {/* Part Four: Supplements */}
        <DividerSupplements data-id="element-605" data-mp="2yncwvfdv2rg5" />
        <PageSupplementQuality data-id="element-606" data-mp="2yn3dianbnijf" />
        <SupplementWheyProtein data-id="element-607" data-mp="32nnc7injmu7o" />
        <SupplementMultiVitamin data-id="element-608" data-mp="32mu34b143smd" />
        <SupplementVitaminD data-id="element-609" data-mp="32n3wm8ld8hwt" />
        <SupplementCoQ10 data-id="element-610" data-mp="2owqljxd6gn39" />
        <SupplementOmega3 data-id="element-611" data-mp="2oxa1j8j9p1en" />
        <SupplementElectrolytes data-id="element-612" data-mp="2ovyzbd5h01pn" />
        <SupplementCreatine data-id="element-613" data-mp="2tvlf9uconw25" />
        <SupplementAshwagandhaMuscle data-id="element-614" data-mp="2tus50jeimof9" />
        <SupplementSleepSupport data-id="element-615" data-mp="2ttqt6cpodxwh" />
        <SupplementMagnesium data-id="element-616" data-mp="2eyawdzxpnnwe" />
        <SupplementAshwagandha data-id="element-617" data-mp="2ex9hfkdkqh9e" />
        <SupplementGlutathione data-id="element-618" data-mp="2ewzrfwsj4a3p" />
        <FoodPhoto4 data-id="element-619" data-mp="2jxdwr72qx5y1" />
        {/* Part Five: Side Effects & Challenges */}
        <DividerSideEffects data-id="element-620" data-mp="2jvb1a7itqklx" />
        <PageAcuteSideEffects data-id="element-621" data-mp="25xw76phmlonm" />
        <PageChronicSideEffects data-id="element-622" data-mp="25ynznrfxf69o" />
        <PageAlcohol data-id="element-623" data-mp="25zpfsabsuiy9" />
        <PagePlateaus data-id="element-624" data-mp="2awpn0okdxrqy" />
        <FoodPhoto5 data-id="element-625" data-mp="2avxp373bfhxi" />
        {/* Part Six: Looking Ahead */}
        <DividerLookingAhead data-id="element-626" data-mp="2ayk6dyg0dbsx" />
        <PageTransitioning data-id="element-627" data-mp="45q77wq2afp9" />
        <PageOutro2 data-id="element-628" data-mp="47kpt4dv1vq6" />
        <PageAboutAuthor2 data-id="element-629" data-mp="446nfw575miq" />
        <Page12 data-id="element-630" data-mp="95ckg65w3vy2" />
      </div>
    </>;
}